// JavaScript Document
//components/signs/view/Sort.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, IconButton, MenuItem, Box, MenuList, Typography} from '@material-ui/core';
import IconUp from '@material-ui/icons/ArrowUpward';
import IconDown from '@material-ui/icons/ArrowDownward';
import IconDelete from '@material-ui/icons/Delete';
//import Fields from './Fields';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow:1,
	},
  	table: {
    	minWidth: 650,
		maxHeight:'calc(100vh - 64px)',
		//maxHeight: '100%'
	},
    fieldlist : {
        minWidth: 200,
        minHeight: 300,
        maxHeight : 500,
        overflow: 'auto'
    },
    listcontrols : {
        display: 'flex',
        flexDirection : 'column',
        width: 50
    }
}));


export default function Sort(props) {
    //inherited variables
    const {view, setView, fields} = props;
    //selected sort item (name)
    const [selected, setSelected] = React.useState(null);
    //all fields
    const allFields = fields();
    //compiled classes
    const classes = useStyles();

    //Add a sort item
    const handleAddSort = (e) => {
        //copy view
        let newView = Object.assign({}, view);
        //add sort item
        newView.lv_sort.push({
            name : e.target.value,
            type : 'ASC'
        });
        //update view
        setView(newView);
    }

    //move sort item up
    const handleMoveUp = (e) => {
        if(!selected) return false;
        //get index of selected item
        let index = view.lv_sort.findIndex(n => n.name === selected);
        //can't move up past 0
        if(index === 0) return false;
        //copy view
        let newView = Object.assign({}, view);
        //remove element from current position
        let field = newView.lv_sort.splice(index, 1)[0];
        //put it back one step up
        newView.lv_sort.splice(index - 1, 0, field);
        //update the view
        setView(newView);
    }

    //move selected item down
    const handleMoveDown = (e) => {
        if(!selected) return false;
        //get the index of selected item
        let index = view.lv_sort.findIndex(n => n.name === selected);
        //can't move down past the end
        if(index === view.lv_sort.length - 1) return false;
        //copy view
        let newView = Object.assign({}, view);
        //remove element from list
        let field = newView.lv_sort.splice(index, 1)[0];
        //put it back one step down
        newView.lv_sort.splice(index + 1, 0, field);
        //update the view
        setView(newView);
    }

    //remove selected sort item
    const handleRemove = (e) => {
        if(!selected) return false;
        //copy view
        let newView = Object.assign({}, view);
        //get element index
        let index = newView.lv_sort.findIndex(n => n.name === selected);
        //remove from list
        newView.lv_sort.splice(index, 1);
        //deselect
        setSelected(null);
        //update the view
        setView(newView);
    }

    //change sort direction
    const handleChangeSortDirection = (e) => {
        if(!selected) return false;
        //copy view
        let newView = Object.assign({}, view);
        //get index
        let index = newView.lv_sort.findIndex(n => n.name === selected);
        //update sort direction
        newView.lv_sort[index].type = e.target.value;
        //update view
        setView(newView);
    }

    //render selected sort item options
    const sortOptions = () => {
        if(!selected) return (<Typography>No column selected</Typography>);
        let field = view.lv_sort.find(n => n.name === selected);
        //let basefield = allFields.find(n => n.name === selected);
        return (
                <Box id="sortoptions" display="flex">
                    <Box id="sortcontrols" className={classes.listcontrols}>
                        <IconButton onClick={handleMoveUp}>
                            <IconUp />
                        </IconButton>
                        <IconButton onClick={handleRemove}>
                            <IconDelete />
                        </IconButton>
                        <IconButton onClick={handleMoveDown}>
                            <IconDown />
                        </IconButton>
                    </Box>
                    <Box id="sortsettings">
                        <TextField
                            id="sort_name"
                            label="Dev name"
                            name="name"
                            value={field.name}
                            disabled={true}
                            fullWidth
                        />
                        <TextField
                            id="sort_direction"
                            label="Direction"
                            name="type"
                            value={field.type || 'ASC'}
                            onChange={handleChangeSortDirection}
                            fullWidth
                            select
                        >  
                            <MenuItem key={0} value='ASC'>Ascending</MenuItem>
                            <MenuItem key={1} value='DESC'>Descending</MenuItem>
                        </TextField>
                    </Box>
                </Box>
            );
        
        
    }

    //render sort UI
    return (
        <Box id="sorting">
            <Box id="addfield">
                <TextField
                    id="add_sort"
                    label="Sort by..."
                    value={null}
                    onChange={handleAddSort}
                    fullWidth
                    select
                >
                {allFields.filter(n => n.type !== 'HIDDEN' && !view.lv_sort.find(f => n.name === f.name)).map((field, i) => (
                    <MenuItem value={field.name} key={i}>{field.label}</MenuItem>
                ))}
                </TextField>
            </Box>
            <Box id="sortcontrol" display="flex">
                <Box id="sortlist" className={classes.fieldlist}>
                    <MenuList>
                        {view.lv_sort.map((field, i) => (
                            <MenuItem 
                                onClick={e => setSelected(field.name)} 
                                value={field.name} 
                                selected={field.name === selected} 
                                key={i}>{allFields.find(f => f.name === field.name).label}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Box>
                {sortOptions()}
            </Box>
        </Box>
    );
}
